import React, { Component } from 'react';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import Script from "next/script"
import PGDataLayer from '../../components/Generic/PGDataLayer/PGDataLayer';
import { contentType } from '../../constants/global';
import config from '../../config';
import PageMetadata from '../../components/Generic/PageMetadata';
import styles from '../../components/Brand/RegistrationForm/RegistrationForm-tw-styles';

class ChildRejection extends Component {
  static propTypes = {
    pageContext: PropTypes.oneOfType([PropTypes.object]).isRequired,
    router: PropTypes.oneOfType([PropTypes.object]).isRequired,
  };
  constructor() {
    super();
    this.state = {
      isBlocked: false,
    };
  }
  static async getInitialProps({ query }) {
    const { locale } = query;

    return {
      pageContext: query,
      locale,
    };
  }
  componentDidMount() {
    const cssLink = document.createElement('link');
    cssLink.setAttribute('rel', 'stylesheet');
    cssLink.setAttribute('href', '/static/css/main_janrain.css');
    document.head.appendChild(cssLink);
    this.checkIfBlocked();
    if (typeof window !== 'undefined') {
      window.checkIfBlocked = this.checkIfBlocked;
    }
  }

  checkIfBlocked = () => {
    const { isBlocked } = this.state;
    if (localStorage.getItem('janrain_mav') && !isBlocked)
      this.setState({ isBlocked: true });
  };

  render() {
    const { isBlocked } = this.state;
    const { pageContext, router } = this.props;

    const constants = require(`../../constants/messages/${pageContext.locale}`);
    return (
      <div>
        <>
          <Script
            id="janrain-childrejection"
            strategy="afterInteractive"
            type="text/javascript"
            src={config.janrainScriptLocation}
          />
          <Script
            id="janrain-childrejection-utils"
            strategy="afterInteractive"
            src="/static/scripts/janrain-utils.js"
          />
        </>
        <PGDataLayer
          locale={pageContext.locale}
          pageType={contentType.registration}
          path={router.asPath}
          title="registration"
        />
        <PageMetadata
          title={constants.user_childRejectionMetaTitle}
          metaTitle={constants.user_childRejectionMetaTitle}
          metaDescription={constants.user_childRejectionMetaDescription}
          orgTitle={constants.user_childRejectionOGTitle}
          orgDescription={constants.user_childRejectionMetaDescription}
        />

        {isBlocked && (
          <div className={styles.childRejectMain}>
            <div className={styles.childRejectDiv}>
              {constants.ChildRejectionErrorMessage}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(ChildRejection);
